export default __webpack_public_path__ + "static/media/css.9ca9c7b0.png";